module.exports = __webpack_public_path__ + "static/media/DQ-Index.96ba33db.png";